"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _common = require("../utils/common");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /* eslint-disable no-underscore-dangle */
/**
 * 对应无极2.0单个数据源的请求实体
 */
var DataApi = /*#__PURE__*/function () {
  function DataApi(table, requester) {
    (0, _classCallCheck2.default)(this, DataApi);
    this.fixSchemaField = function ($data, schemaList) {
      if (!$data) return;
      var data = $data;
      var fields = schemaList === null || schemaList === void 0 ? void 0 : schemaList.fields;
      if (Array.isArray(fields)) {
        Object.keys(data).forEach(function (key) {
          var findField = fields.find(function (item) {
            return item.id === key;
          });
          if (!findField && key !== '_id') {
            delete data[key];
          }
        });
      }
    };
    this.table = table;
    this.requester = requester;
  }
  /**
   * 获取一条数据
   */
  (0, _createClass2.default)(DataApi, [{
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, _ref2) {
        var id, uuid, errMsg, _this$table, tableKey, schemaList, rawPrimaryKey, result, _ref3, code, message, data, returnData;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id;
              uuid = _ref2.uuid, errMsg = _ref2.errMsg;
              if (this.validInterface('get', errMsg)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _this$table = this.table, tableKey = _this$table.tableKey, schemaList = _this$table.schemaList, rawPrimaryKey = _this$table.rawPrimaryKey;
              _context.next = 7;
              return this.requester.get({
                query: {
                  id: id,
                  __dm_uuid: uuid
                },
                body: {
                  id: id
                }
              });
            case 7:
              result = _context.sent;
              _ref3 = result.body || {}, code = _ref3.code, message = _ref3.message, data = _ref3.data;
              if (!(code !== 0)) {
                _context.next = 13;
                break;
              }
              errMsg.push("".concat(tableKey, "[").concat(id, "]\u7684get\u8BF7\u6C42\u5F02\u5E38:").concat(message));
              _context.next = 17;
              break;
            case 13:
              if (data && !data._id) {
                data._id = (0, _common.getValueByPath)(data, rawPrimaryKey);
              }
              returnData = data;
              this.fixSchemaField(returnData, schemaList);
              return _context.abrupt("return", returnData);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
    /**
     * 新增一条数据
     */
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2($data, _ref4) {
        var uuid, errMsg, _this$table2, primaryKey, tableKey, schemaList, result, _ref5, code, message, _ref5$data, data;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              uuid = _ref4.uuid, errMsg = _ref4.errMsg;
              if (this.validInterface('create', errMsg)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _this$table2 = this.table, primaryKey = _this$table2.primaryKey, tableKey = _this$table2.tableKey, schemaList = _this$table2.schemaList;
              this.fixSchemaField($data, schemaList);
              _context2.next = 7;
              return this.requester.create({
                query: {
                  __dm_uuid: uuid
                },
                body: $data
              });
            case 7:
              result = _context2.sent;
              _ref5 = result.body || {}, code = _ref5.code, message = _ref5.message, _ref5$data = _ref5.data, data = _ref5$data === void 0 ? {} : _ref5$data;
              if (!(code !== 0)) {
                _context2.next = 13;
                break;
              }
              errMsg.push("".concat(tableKey, "\u7684create\u8BF7\u6C42\u5F02\u5E38:").concat(message));
              _context2.next = 14;
              break;
            case 13:
              return _context2.abrupt("return", data[primaryKey]);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function create(_x3, _x4) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
    /**
     * 编辑一条数据
     */
  }, {
    key: "update",
    value: function () {
      var _update = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(data, _ref6, originalData) {
        var uuid, errMsg, _this$table3, primaryKey, tableKey, schemaList, result, _ref7, code, message;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              uuid = _ref6.uuid, errMsg = _ref6.errMsg;
              if (this.validInterface('update', errMsg)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              if (this.requester.collectionData.type !== 'db') {
                // 非db类型，不管字段是否修改全部透穿
                // eslint-disable-next-line
                data = _objectSpread(_objectSpread({}, originalData), data);
              }
              _this$table3 = this.table, primaryKey = _this$table3.primaryKey, tableKey = _this$table3.tableKey, schemaList = _this$table3.schemaList;
              this.fixSchemaField(data, schemaList);
              _context3.next = 8;
              return this.requester.update({
                query: {
                  id: data[primaryKey],
                  __dm_uuid: uuid
                },
                body: data
              });
            case 8:
              result = _context3.sent;
              _ref7 = result.body || {}, code = _ref7.code, message = _ref7.message;
              if (!(code !== 0)) {
                _context3.next = 13;
                break;
              }
              errMsg.push("".concat(tableKey, "[").concat(data[primaryKey], "]\u7684update\u8BF7\u6C42\u5F02\u5E38:").concat(message));
              return _context3.abrupt("return", false);
            case 13:
              return _context3.abrupt("return", true);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function update(_x5, _x6, _x7) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
    /**
     * 删除一条数据
     */
  }, {
    key: "delete",
    value: function () {
      var _delete2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(_ref8, _ref9) {
        var id, uuid, errMsg, tableKey, result, _ref10, code, message;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              id = _ref8.id;
              uuid = _ref9.uuid, errMsg = _ref9.errMsg;
              if (this.validInterface('delete', errMsg)) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              tableKey = this.table.tableKey;
              _context4.next = 7;
              return this.requester.delete({
                query: {
                  id: id,
                  __dm_uuid: uuid
                },
                body: {
                  id: id
                }
              });
            case 7:
              result = _context4.sent;
              _ref10 = result.body || {}, code = _ref10.code, message = _ref10.message;
              if (code !== 0) {
                errMsg.push("".concat(tableKey, "[").concat(id, "]\u7684delete\u8BF7\u6C42\u5F02\u5E38:").concat(message));
              }
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _delete(_x8, _x9) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "list",
    value: function () {
      var _list = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(_ref11) {
        var _this = this;
        var uuid, errMsg, _this$table4, tableKey, relationValues, rawPrimaryKey, _this$requester, collectionData, get, list, allPromise, allResult;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              uuid = _ref11.uuid, errMsg = _ref11.errMsg;
              _this$table4 = this.table, tableKey = _this$table4.tableKey, relationValues = _this$table4.relationValues, rawPrimaryKey = _this$table4.rawPrimaryKey;
              _this$requester = this.requester, collectionData = _this$requester.collectionData, get = _this$requester.get, list = _this$requester.list;
              if (!(Object.keys(relationValues).length === 0 || collectionData.type === 'db')) {
                _context5.next = 7;
                break;
              }
              _context5.next = 6;
              return this.rawList({
                uuid: uuid,
                errMsg: errMsg
              });
            case 6:
              return _context5.abrupt("return", _context5.sent);
            case 7:
              if (!(typeof get === 'function' && collectionData.cgiInfo.get)) {
                _context5.next = 17;
                break;
              }
              if (!relationValues[rawPrimaryKey]) {
                _context5.next = 15;
                break;
              }
              allPromise = [];
              allResult = [];
              relationValues[rawPrimaryKey].forEach(function (id) {
                allPromise.push(_this.get({
                  id: id
                }, {
                  uuid: uuid,
                  errMsg: errMsg
                }).then(function (result) {
                  if (result) {
                    allResult.push(result);
                  }
                }));
              });
              _context5.next = 14;
              return (0, _common.allSettled)(allPromise);
            case 14:
              return _context5.abrupt("return", allResult);
            case 15:
              errMsg.push("\u6570\u636E\u6E90[".concat(tableKey, "]get\u63A5\u53E3\u4E0D\u6EE1\u8DB3\u4E3B\u952E\u5173\u8054\u67E5\u8BE2: ").concat(JSON.stringify(collectionData)));
              return _context5.abrupt("return");
            case 17:
              if (!(typeof list === 'function' && collectionData.cgiInfo.list)) {
                _context5.next = 21;
                break;
              }
              _context5.next = 20;
              return this.rawList({
                uuid: uuid,
                errMsg: errMsg
              });
            case 20:
              return _context5.abrupt("return", _context5.sent);
            case 21:
              errMsg.push("\u6570\u636E\u6E90[".concat(tableKey, "]\u672A\u914D\u7F6Eget\u3001list\u63A5\u53E3: ").concat(JSON.stringify(collectionData)));
            case 22:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function list(_x10) {
        return _list.apply(this, arguments);
      }
      return list;
    }()
    /**
    * 获取多条数据
    */
  }, {
    key: "rawList",
    value: function () {
      var _rawList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(_ref12) {
        var _this2 = this;
        var uuid, errMsg, _this$table5, tableKey, tableParams, relationValues, schemaList, rawPrimaryKey, _tableParams$filter, filter, sort, sortObj, query, result, _ref13, code, message, data;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              uuid = _ref12.uuid, errMsg = _ref12.errMsg;
              if (this.validInterface('list', errMsg)) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              _this$table5 = this.table, tableKey = _this$table5.tableKey, tableParams = _this$table5.tableParams, relationValues = _this$table5.relationValues, schemaList = _this$table5.schemaList, rawPrimaryKey = _this$table5.rawPrimaryKey;
              _tableParams$filter = tableParams.filter, filter = _tableParams$filter === void 0 ? [] : _tableParams$filter, sort = tableParams.sort;
              Object.keys(relationValues).forEach(function (key) {
                filter.push({
                  k: key,
                  v: relationValues[key],
                  o: '='
                });
              });
              sortObj = this.getSortStr(sort) || {};
              query = _objectSpread(_objectSpread(_objectSpread({}, tableParams), {}, {
                filter: (0, _common.convertFilter)(filter, schemaList)
              }, sortObj), {}, {
                __dm_uuid: uuid
              });
              _context6.next = 10;
              return this.requester.list({
                query: query,
                body: tableParams
              });
            case 10:
              result = _context6.sent;
              _ref13 = result.body || {}, code = _ref13.code, message = _ref13.message, data = _ref13.data;
              if (!(code !== 0)) {
                _context6.next = 16;
                break;
              }
              errMsg.push("".concat(tableKey, "\u7684list\u8BF7\u6C42\u5F02\u5E38:").concat(message));
              _context6.next = 18;
              break;
            case 16:
              (data || []).forEach(function ($item) {
                var item = $item;
                if (!item._id) {
                  item._id = (0, _common.getValueByPath)(item, rawPrimaryKey);
                  ;
                }
                _this2.fixSchemaField(item, schemaList);
              });
              return _context6.abrupt("return", data);
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function rawList(_x11) {
        return _rawList.apply(this, arguments);
      }
      return rawList;
    }()
    /**
     * 获取多条数据总数
     */
  }, {
    key: "count",
    value: function () {
      var _count = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(_ref14) {
        var uuid, errMsg, _this$table6, tableKey, filter, schemaList, result, _ref15, code, message, _ref15$data, data;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              uuid = _ref14.uuid, errMsg = _ref14.errMsg;
              if (this.validInterface('count', errMsg)) {
                _context7.next = 3;
                break;
              }
              return _context7.abrupt("return");
            case 3:
              _this$table6 = this.table, tableKey = _this$table6.tableKey, filter = _this$table6.tableParams.filter, schemaList = _this$table6.schemaList;
              _context7.next = 6;
              return this.requester.count({
                query: {
                  filter: (0, _common.convertFilter)(filter, schemaList),
                  __dm_uuid: uuid
                },
                body: {
                  filter: filter
                }
              });
            case 6:
              result = _context7.sent;
              _ref15 = result.body || {}, code = _ref15.code, message = _ref15.message, _ref15$data = _ref15.data, data = _ref15$data === void 0 ? {} : _ref15$data;
              if (!(code !== 0)) {
                _context7.next = 12;
                break;
              }
              errMsg.push("".concat(tableKey, "\u7684count\u8BF7\u6C42\u5F02\u5E38:").concat(message));
              _context7.next = 13;
              break;
            case 12:
              return _context7.abrupt("return", data);
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function count(_x12) {
        return _count.apply(this, arguments);
      }
      return count;
    }()
    /**
     * 获取schema
     */
  }, {
    key: "getEntitySchema",
    value: function getEntitySchema(_ref16) {
      var errMsg = _ref16.errMsg;
      var schema = this.requester.getEntitySchema();
      if (!schema) {
        errMsg.push("".concat(this.table.tableKey, "\u7684getEntitySchema\u8BF7\u6C42\u5F02\u5E38:").concat(schema));
      } else {
        return schema;
      }
    }

    /**
     * 屏蔽Schema不存在的字段
     * (只屏蔽第一层：db类型只有一层，而http也不再深度遍历)
     * @param {*} $data
     * @param {*} schemaList
     */
  }, {
    key: "getSortStr",
    value: function getSortStr(sortList) {
      if (!sortList || sortList.length === 0) return;
      var sortArray = [];
      var orderArray = [];
      sortList.forEach(function (item) {
        sortArray.push(item.k);
        orderArray.push(item.o);
      });
      return {
        sort: sortArray.join(','),
        order: orderArray.join(',')
      };
    }

    /**
     * 验证接口是否存在
     * @param {*} type
     * @param {*} errMsg
     * @returns
     */
  }, {
    key: "validInterface",
    value: function validInterface(type, errMsg) {
      var tableKey = this.table.tableKey;
      var collectionData = this.requester.collectionData;
      if (typeof this.requester[type] === 'function' && collectionData.cgiInfo[type]) {
        return true;
      }
      errMsg.push("\u6570\u636E\u6E90[".concat(tableKey, "]\u672A\u914D\u7F6E").concat(type, "\u63A5\u53E3"));
      return false;
    }
  }]);
  return DataApi;
}();
var _default = DataApi;
exports.default = _default;